import { useSelector, shallowEqual } from 'react-redux';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { useRestaurantSettings } from '../../hooks/useRestaurantSettings';
import { SITE_NAME, shareImage, shareTitle } from '../../helpers/shareMeta';

const MetaTags = () => {
  const content = useSelector(
    (state: any) => state.content?.data,
    shallowEqual,
  );
  const siteTitle = useSelector(
    (state: any) =>
      state.navroot?.data?.navroot?.title ||
      state.site?.data?.['plone.site_title'],
  );
  const settings = useRestaurantSettings();

  const title = shareTitle(
    content?.opengraph_title || content?.title,
    siteTitle,
  );
  const description =
    content?.opengraph_description || content?.description || '';
  const image = shareImage(content, settings.default_share_image);

  // Volto's own tags give the document title, the canonical link, og:url
  // and the description. These tags render later, so they win on duplicates.
  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteTitle || SITE_NAME} />
      <meta property="og:locale" content="fr_BE" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image.url} />}
      {image?.width && (
        <meta property="og:image:width" content={String(image.width)} />
      )}
      {image?.height && (
        <meta property="og:image:height" content={String(image.height)} />
      )}
      <meta
        name="twitter:card"
        content={image ? 'summary_large_image' : 'summary'}
      />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image.url} />}
    </Helmet>
  );
};

export default MetaTags;
